export default __webpack_public_path__ + "static/media/background-intro.e5f72c43.jpg";